import { render, staticRenderFns } from "./homeConfigModal.vue?vue&type=template&id=28f1d4e6&scoped=true&"
import script from "./homeConfigModal.vue?vue&type=script&lang=js&"
export * from "./homeConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./homeConfigModal.vue?vue&type=style&index=0&id=28f1d4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1d4e6",
  null
  
)

export default component.exports